import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { MyCardsBoxesTypePage } from 'pages/MyCardsBoxesTypePage';

type Props = {
  sport: Sport;
  type: string;
};

export const BoxesTypePage = ({ sport, type }: Props) => {
  return (
    <MyCardsBoxesTypePage sport={sport} type={type} withPageHeader={false} />
  );
};
